module.exports = __webpack_public_path__ + "static/img/学生信息.98d55be.png";


//////////////////
// WEBPACK FOOTER
// ./src/v2/assets/images/学生信息.png
// module id = kn+Q
// module chunks = 129